import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import DialogContent from '@mui/material/DialogContent';
import Fade from '@mui/material/Fade';
import MuiDialog, { dialogClasses } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { DIALOG_WIDTH } from '../constants/dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
const PickersModalDialogRoot = styled(MuiDialog)({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
});
const PickersModalDialogContent = styled(DialogContent)({
  '&:first-of-type': {
    padding: 0
  }
});
export function PickersModalDialog(props) {
  var _ref, _slots$dialog, _ref2, _slots$mobileTransiti, _slotProps$mobileTran, _slots$mobilePaper, _slotProps$mobilePape;
  const {
    children,
    onDismiss,
    open,
    components,
    componentsProps,
    slots,
    slotProps
  } = props;
  const Dialog = (_ref = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : components == null ? void 0 : components.Dialog) != null ? _ref : PickersModalDialogRoot;
  const Transition = (_ref2 = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : components == null ? void 0 : components.MobileTransition) != null ? _ref2 : Fade;
  return /*#__PURE__*/_jsx(Dialog, _extends({
    open: open,
    onClose: onDismiss
  }, componentsProps == null ? void 0 : componentsProps.dialog, {
    TransitionComponent: Transition,
    TransitionProps: (_slotProps$mobileTran = slotProps == null ? void 0 : slotProps.mobileTransition) != null ? _slotProps$mobileTran : componentsProps == null ? void 0 : componentsProps.mobileTransition,
    PaperComponent: (_slots$mobilePaper = slots == null ? void 0 : slots.mobilePaper) != null ? _slots$mobilePaper : components == null ? void 0 : components.MobilePaper,
    PaperProps: (_slotProps$mobilePape = slotProps == null ? void 0 : slotProps.mobilePaper) != null ? _slotProps$mobilePape : componentsProps == null ? void 0 : componentsProps.mobilePaper,
    children: /*#__PURE__*/_jsx(PickersModalDialogContent, {
      children: children
    })
  }));
}